import { render, staticRenderFns } from "./PaymentProblemDetail.vue?vue&type=template&id=2e587b17&scoped=true"
import script from "./PaymentProblemDetail.vue?vue&type=script&lang=js"
export * from "./PaymentProblemDetail.vue?vue&type=script&lang=js"
import style0 from "./PaymentProblemDetail.vue?vue&type=style&index=0&id=2e587b17&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e587b17",
  null
  
)

export default component.exports